/**
 * @hidden
 */
var noop = function () { };
export { noop };
